module.exports = __webpack_public_path__ + "static/8-d545906518bee20d398299e7946f3131.jpg";